import React from "react";
import outline from "../../assets/icons/home_blog.svg";
import blogs from "../Blog/blogdata";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const HomeBlogs = () => {
  return (
    <div className=" xl:py-28 lg:py-20 md:py-14 py-10 relative  bg-gradient-to-br from-[#a3b8e8] from-[10%] to-white">
      <div className="bottom-0  right-0 absolute">
        <img src={outline} alt="outline" />
      </div>
      <div data-aos="fade-up" className="xl:w-[1280px] w-11/12 xl:px-10 px-0 2xl:px-0 mx-auto flex justify-center items-center flex-col z-10">
        <span className="text-xl font-medium text-[#1d9e75] uppercase border-b border-[#B87333] px-2 py-1.5 ">
          Read Blogs
        </span>
        <h2 className="lg:text-4xl md:text-3xl text-xl text-center font-bold mt-2 text-matcha leading-tight px-8">
          Your Health, My Words
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-8  xl:mt-28 lg:mt-20 md:mt-16 mt-12">
          {blogs.slice(0, 3).map((blog) => (
            <div
              key={blog.title}
              className="group relative flex flex-col rounded-lg bg-[#E8EDF2] overflow-hidden shadow-md hover:shadow-2xl transition-all duration-500 hover:-translate-y-2"
            >
              {/* Image */}
              <div className="relative overflow-hidden h-56">
                <img
                  src={blog.image}
                  alt={blog.title}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                {/* Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />

                {/* Date */}
                <div className="absolute top-4 left-4 bg-[#1d9e75] backdrop-blur-md text-white text-sm px-4 py-1 rounded-full">
                  {blog.date}
                </div>
              </div>
              {/* Content */}
              <div className="flex flex-col justify-between flex-1 sm:p-5 p-3">
                <div>
                  <h3 className=" mb-3 line-clamp-2 md:text-xl text-lg font-bold text-matcha">
                    {blog.title}
                  </h3>

                  <p className="text-matcha leading-relaxed mb-3 line-clamp-3">
                    {blog.description}
                  </p>
                </div>
                <Link
                  to={`/blogs/${blog.link}`}
                  className="bg-matcha py-3 w-36 text-white text-base font-semibold border border-matcha  flex flex-row items-center justify-center gap-2 rounded-lg hover:bg-transparent hover:text-matcha duration-200 transition"
                >
                  Read More <ArrowRight strokeWidth={1} />
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HomeBlogs;
